import { ResumeFunnelButton } from '@hungryroot/funnel';
import styles from './CtaHeader.module.css';
import clsx from 'clsx';

const CtaHeader = ({
  isFoodsPage,
  isOnPDP,
  preCheckout,
  surveyStartedFoods,
}) => {
  const renderHeroText = () => {
    if (isFoodsPage) {
      return 'Need a fridge refill?';
    }
    return 'Recipes that save you time.';
  };

  const renderHeroSubtext = () => {
    if (isFoodsPage) {
      return (
        <h2 className="subtext hr-mb-32 precheckout hr-paragraph hr-shadow hr-center-txt">
          We deliver everything from fresh produce to premium proteins.{' '}
          <br className={styles['hr-desktop']} />
          Take the quiz and we'll suggest groceries and recipes you'll love.
        </h2>
      );
    }
    return (
      <h2 className="subtext hr-mb-32 precheckout hr-paragraph hr-shadow hr-center-txt">
        With every delivery, you'll get top-rated, tasty recipes that cook up
        quickly. See a sneak peek here, and sign up today to access thousands
        more.
      </h2>
    );
  };

  const renderHeaderSection = () => {
    if (!preCheckout && !isOnPDP) {
      return (
        <div className="splash-area hr-mb-8">
          <h1
            className={clsx('hr-sectra-hero hr-mb-16', styles['weight-heavy'])}
          >
            The Cookbook
          </h1>
          <h2 className={clsx('subtext hr-shadow', styles['weight-heavy'])}>
            Food boredom? Not here. See all recipes + ways to use your
            ingredients.
          </h2>
        </div>
      );
    }
    return (
      <div
        className={`splash-area hr-mb-8 precheckout ${
          isFoodsPage ? 'foods' : 'cookbook'
        }`}
      >
        <h1 className="hr-sectra-hero hr-mb-16">{renderHeroText()}</h1>
        {renderHeroSubtext()}
        <ResumeFunnelButton
          resumeQuizText="Finish Quiz"
          startQuizText="Take Quiz"
        >
          {({ text, route }) => {
            return (
              <a href={route}>
                <div className="hr-btn-blue preCheckoutBtn">{text}</div>
              </a>
            );
          }}
        </ResumeFunnelButton>
      </div>
    );
  };

  return (
    <section
      className={`recipe-search-app-section${
        preCheckout ? ' preCheckout' : ''
      }${isFoodsPage ? ' foods' : ' cookbook'}`}
    >
      {renderHeaderSection()}
    </section>
  );
};

export default CtaHeader;
